export const DESKTOP_NAVIGATION_WIDTH = 192;
export const SMALL_SCREEN_MAX_WIDTH = 600;
export const APP_MAX_WIDTH = 792;
